export default {
  'Invoices.noInvoices': {
    en: 'You have no invoices yet',
    fr: 'Une fois que vous aurez engagé votre premier.e musicien.ne, vos factures apparaîtront ici.',
  },
};
